import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

export interface CoreMetricItemProps {
  title?: string
  description?: string
  className?: string
  children: ReactNode
  onClick?: () => void
}

export function CoreMetricItem(props: CoreMetricItemProps) {
  const { title, description, children, className, ...rest } = props
  return (
    <Card
      className={cn(
        'flex flex-col justify-between cursor-pointer bg-white/10',
        className,
      )}
      {...rest}
    >
      <CardHeader className="py-2">
        <CardTitle className="text-lg">{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="pb-4">{children}</CardContent>
    </Card>
  )
}
